import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { reduxForm } from 'redux-form';
import Alert from '../../../shared/components/Alert';

class AddPaymentModal extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      toggle: PropTypes.func.isRequired,
      formdata: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.shape({
           value: PropTypes.string,
           label: PropTypes.string,
         }),
      ]),
      errorMsg: PropTypes.string,
      handleChange: PropTypes.func.isRequired,
      handleSubmit: PropTypes.func,
      balance: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.number,
      ]),
   };

   static defaultProps = {
      formdata: '',
      errorMsg: '',
      modal: false,
      handleSubmit: (e) => {
         e.preventDefault();
         console.log('submitted');
      },
      balance: 0,
   };

   constructor() {
      super();
      this.state = {};
   }

   render() {
      const {
         modal, toggle, formdata, errorMsg, handleChange, handleSubmit, balance,
      } = this.props;

      return (
         <div>
            <Modal
               isOpen={modal}
               className="modal-dialog--primary modal-dialog--header"
            >
               <div className="modal__header bg_blue">
                  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                  <h4 className="bold-text  modal__title">Payment</h4>
               </div>
               <form id="product_form" onSubmit={handleSubmit}>
                  <div className="modal__body p-t-10">
                     { errorMsg && (
                        <div className="notif_msg">
                           <Alert color="danger" className="alert--colored">
                           <p><span className="fa fa-exclamation">&nbsp;</span> { errorMsg }</p>
                           </Alert>
                        </div>
                        )
                     }
                     <div className="form form--horizontal m-t-10">
                        <div className="form__form-group">
                           <span className="form__form-group-label">Balance:</span>
                           <div className="form__form-group-field">
                              <span className="text-danger">&#x20B1; {balance !== null ? balance : 0}</span>
                           </div>
                        </div>
                        <div className="form__form-group">
                           <span className="form__form-group-label">Amount <b className="text-danger">*</b></span>
                           <div className="form__form-group-field">
                              <input type="text" name="amount" value={formdata && formdata.amount ? formdata.amount : ''} placeholder="Amount" onChange={e => handleChange(e, 'number')} />
                           </div>
                        </div>
                     </div>
                  </div>
                  <ButtonToolbar className="modal__footer">
                     <Button color="primary">Submit</Button>
                     <Button onClick={toggle}>Cancel</Button>
                  </ButtonToolbar>
               </form>
            </Modal>
         </div>
      );
   }
}

export default reduxForm({
  form: 'AddPaymentModal', // a unique identifier for this form
})(AddPaymentModal);
